import http from '@/utils/ajax'
import { DEBUG_INIT_LOADING, DEBUG_INIT_SUCCESS, DEBUG_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

export const actions = {
  async initDebug({ commit, state }) {
    commit(DEBUG_INIT_LOADING)
    const apiUrl = state.permitWidgets.debug
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(DEBUG_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(DEBUG_INIT_FAIL)
      }
    } else {
      commit(DEBUG_INIT_FAIL)
    }
  }
}
